import React from 'react';
import Head from 'next/head';
import Scripts from 'src/Scripts';
import { PrimaryLayout, PrimaryLayoutProps, RouteFields } from '@greystar/ui';
import { seoHost } from '@greystar/lib';

const Layout = ({ layoutData, headLinks }: PrimaryLayoutProps): JSX.Element => {
  const { route, context } = layoutData.sitecore;
  const fields = route?.fields as RouteFields;

  const faqSchemaDetails = fields?.faqSchema?.value ? fields.faqSchema.value : null;
  const organizationSchemaDetails = fields?.organizationSchema?.value
    ? fields.organizationSchema.value
    : null;

  return (
    <>
      <Scripts />
      <Head>
        {faqSchemaDetails && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: faqSchemaDetails }}
          />
        )}
        {organizationSchemaDetails && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: organizationSchemaDetails }}
          />
        )}
        <link
          rel="canonical"
          href={`${seoHost}${context.itemPath !== '/' ? context.itemPath : ''}`}
        />
      </Head>

      <PrimaryLayout layoutData={layoutData} headLinks={headLinks} />
    </>
  );
};

export default Layout;
